import React from 'react';
import { connect } from 'react-redux';
import { Tabs, Collapse } from 'antd';
import PropTypes from 'prop-types';
import LoanDetails from './LoanDetails';
import {
  generateCsvConfigs,
  generateCsvData,
  getGlobalSettings
} from '../utils';
import { Container, Title, StyledTabs, DownloadWrapper } from './styled';
import { LOAN_DETAILS_GS_QUERY } from './constants';
import DownloadCSV from '../../../components/DownloadCSV';
import { downloadAMLSTMCommonCustomerLoanDetails } from '../../../redux/actions/tmCommon';

const { TabPane } = Tabs;
const { Panel } = Collapse;

export const AssociatedAccounts = ({
  dispatch,
  customerId,
  collapsible,
  settings,
  totalCount,
  downloadedData
}) => {
  const { widgetConfig, isVisible, widgetName } = getGlobalSettings({
    settings,
    gsQuery: LOAN_DETAILS_GS_QUERY
  });

  const onDownloadClick = () => {
    dispatch(
      downloadAMLSTMCommonCustomerLoanDetails({
        customerId,
        limit: 5000,
        offset: 0
      })
    );
  };

  const renderTabs = (
    <StyledTabs
      defaultActiveKey="1"
      tabBarExtraContent={
        <DownloadWrapper>
          <DownloadCSV
            csvData={generateCsvData(downloadedData || [])}
            csvHeaders={generateCsvConfigs({
              settings: widgetConfig
            })}
            fileName="LoanDetails.csv"
            onDownloadClick={onDownloadClick}
            disabled={totalCount === 0}
          />
        </DownloadWrapper>
      }>
      {isVisible && (
        <TabPane key="1" tab={`${widgetName} (${totalCount})`}>
          <LoanDetails customerId={customerId} widgetConfig={widgetConfig} />
        </TabPane>
      )}
    </StyledTabs>
  );

  return (
    <Container defaultActiveKey={['1']}>
      {collapsible ? (
        <Collapse
          ghost
          bordered={false}
          defaultActiveKey={['1']}
          expandIconPosition="right">
          <Panel key="1" header={<Title>Associated Accounts</Title>}>
            {renderTabs}
          </Panel>
        </Collapse>
      ) : (
        <>
          <Title>Associated Accounts</Title>
          {renderTabs}
        </>
      )}
    </Container>
  );
};

AssociatedAccounts.propTypes = {
  dispatch: PropTypes.func.isRequired,
  customerId: PropTypes.string,
  settings: PropTypes.object.isRequired,
  collapsible: PropTypes.bool,
  totalCount: PropTypes.number,
  downloadedData: PropTypes.array
};

const mapStateToProps = ({ amlsTMCommon }) => {
  const { data } = amlsTMCommon.customerLoanDetails;
  const {
    data: { payload }
  } = amlsTMCommon.downloadedLoanDetails;

  return {
    totalCount: data.total || 0,
    downloadedData: payload
  };
};

export default connect(mapStateToProps)(AssociatedAccounts);
